<template>
    <div class="chart" id="mychart" v-if="refresh" ref="mychart"></div>
</template>

<script>
/* eslint-disable */
import { get } from '@/api/index'
import { mapState, mapActions } from 'vuex'
import { timeReduce } from '@/utils/common'

export default {
    data() {
        return {
            xData: [],
            aData: [],
            yData: [],
            aType: '',
            bType: '',
            menuKey: 1,
            refresh: true,
            eventParam: {},
            timeout: null,
            timeRank: '1T',
            thisCurrency: '',
            sliderFlag: 0,

            aDataY: [],
            bDataY: [],
            dataX: [],
            dataY: [],
            hTime: '',
            bourseObj: {},
            bourseSelectObj: ['', 'okex', 'huobi'],
            zh_name: [],
        }
    },
    mounted() {
        
    },
    computed: {
        ...mapState([
            'tradeTypeObj'
        ])
    },
    watch: {
        yData: function () {
            // 调用子组件中
            this.initMarketEcharts(this.xData, this.yData, this.aType, this.bType);
        }
    },
    methods: {
        ...mapActions([
            'getKTime'
        ]),
        // 初始化 echarts
        initMarketEcharts(xData, yData, aType, bType) {
            $(this.$el).css('width', $('.el-popover').width())
            var myChart = this.$echarts.init(this.$el);
            
            if (this.zh_name.length > 0) {
                var legendName = this.zh_name[0]+'-'+this.zh_name[1];
            }
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    position: [0, 0]
                },
                grid:[{
                    left: '3%',
                    top: '5%',
                    height: '75%'
                }],
                legend: {
                    data: [legendName],
                    textStyle: {
                        color: '#676a6c'
                    }
                },
                dataZoom: [{
                    show: true,
                    realtime: true,
                    start: 50,
                    end: 100
                },
                {
                    type: 'inside',
                    start: 70,
                    end: 100,
                    height: 20
                }],
                xAxis: [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : xData,
                        axisLabel: {
                            textStyle: {
                                fontSize: 10
                            },
                        },
                        axisTick: {
                            show: false,
                            interval: 2,
                            length: 10
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#676a6c'
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type : 'value',
                        position: 'right',
                        axisLabel : {
                            formatter: '{value}%',
                            
                        },
                        splitNumber: 10,
                        splitLine: {
                            show: false,
                            lineStyle: {
                                type: 'dashed',
                                color: '#676a6c'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#676a6c'
                            }
                        },
                    }
                ],
                series: [
                    {
                        name: legendName,
                        type:'line',
                        symbol: 'none',
                        symbolSize: 1,
                        smooth: true,
                        data: yData,
                        lineStyle: {
                            width: 0
                        },
                        areaStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(34, 166, 148, 1)'
                                },{
                                    offset: 1,
                                    color: 'rgba(34, 166, 148, 1)',
                                }], false),
                            }
                        },
                    },
                ]
            }

            myChart.setOption(option);
            var that = this;
            // 图表缩放事件
            myChart.on('datazoom', (param) => {
                if (param.hasOwnProperty('batch')) {
                    if (param.batch[0].start == 0) {
                        // 防抖动
                        if (that.timeout) {
                            clearTimeout(that.timeout);
                        }
                        that.timeout = setTimeout(() => {
                            this.sliderFlag = -1;
                            var endTime = String(this.xData[0]).split(' ')[0];
                            var timeParm = this.getStartTime(this.timeRank, endTime);
                            var initYear = endTime.split('-')[0];
                            var initMonth = endTime.split('-')[1];

                            if (Number(initYear) < 2019 && Number(initMonth <= 12)) {
                                clearTimeout(that.timeout);
                            } else {
                                this.getKTime(timeParm).then(resp => {
                                    var startTime = resp.result;
                                    var startYear = Number(startTime.split('-')[0]);
                                    var startMonth = Number(startTime.split('-')[1]);

                                    if (startYear < 2019 && startMonth <= 12) {// 如果交易时间 在2018/12 之前， 则起始时间定为 
                                        var startTime = '2018-12-01';
                                    } 

                                    if (this.timeRank.includes('H') || this.timeRank.includes('T')) {// 当时间段为1小时，结束时间往前一天
                                        var timeParam = {
                                            'startTime': endTime,
                                            'distanceDays': '-1D'
                                        };
                                        // 往前推一天
                                        this.getKTime(timeParam).then(resp => {
                                            var timeRange = {
                                                'startTime': startTime,
                                                'endTime': resp.result
                                            };
                                            this.handleData(this.thisCurrency, this.timeRank, timeRange);
                                        })
    
                                    } else {
                                        var timeRange = {
                                            'startTime': startTime,
                                            'endTime': endTime
                                        };
                                        this.handleData(this.thisCurrency, this.timeRank, timeRange);
                                    }

                                })
                            }
                        }, 1000)
                    }
                }
            });

            window.onresize = function () {
                $(that.$el).css('width', $('.el-popover').width());
                myChart.resize();
            }
        },

        // 获取k线 参数，数据整理、计算
        sortData(currencys, aType, bType, timerPoint, typeBourse, zhName=null) {
            // 每次被调用时， 清空列表
            this.aType = aType;
            this.bType = bType;
            this.aData = [];
            this.yData = [];
            this.xData = [];
            let x_data_list = [];
            this.timeRank = timerPoint;
            this.thisCurrency = currencys;
            var transTypeArr = ['CQ', 'NW', 'CW', 'CS', 'SS'];
            this.bourseObj = {
                "aBourse": this.bourseSelectObj[typeBourse['aBourse']],
                "bBourse": this.bourseSelectObj[typeBourse['bBourse']]
            }

            if (zhName) {
                this.zh_name = zhName;
            } else {
                this.zh_name = [this.tradeTypeObj[aType], this.tradeTypeObj[bType]];
            }

            this.getSomeKdata(aType, currencys.aCurrencys, timerPoint, this.bourseObj.aBourse).then(data => {
                // 数据处理，筛选
                var data_a = data[currencys.aCurrencys];
                for (var i=0; i<data_a.length; i++) {
                    // this.xData.push(data_a[i].candle_begin_time);
                    this.aData.push(data_a[i].close);
                }
                this.getSomeKdata(bType, currencys.bCurrencys, timerPoint, this.bourseObj.bBourse).then(data => {
                    // 数据处理，筛选 
                    var data_b = data[currencys.bCurrencys];
                    if (data_b > data_a) {
                        var data_length = data_a.length; 
                    } else {
                        var data_length = data_b.length;
                    }
                    for (var i=0; i<data_length; i++) {
                        // (远 - 近) / 近
                        var a_index = transTypeArr.indexOf(aType);
                        var b_index = transTypeArr.indexOf(bType);
                        this.xData.push(data_b[i].candle_begin_time);

                        if (a_index > b_index) {// a：近， b：远
                            var value = (Number(data_b[i].close) - Number(this.aData[i])) / Number(this.aData[i]) * 100;
                        } else {// a: 远，b：近
                            var value = (Number(this.aData[i]) - Number(data_b[i].close)) / Number(data_b[i].close) * 100;
                        }
                        this.yData.push(value.toFixed(4)); 
                    }
                });
            });
        },  

        // 获取 k线数据
        getSomeKdata(types, currency, timeNode, bourse) {
            return new Promise((resolve, reject) => {
                var url = this.$url_LN + '/web/get/kline/data';
                // 获取当前时间
                var timeStr = this.UTCtimeStr();
                var paramTime = this.getStartTime(timeNode, timeStr.endTime);

                this.getKTime(paramTime).then((resp) => {
                    var param = {
                        'excheng': bourse,
                        'currencys': JSON.stringify(currency),
                        'types': types,
                        'granularity': timeNode || '1T',
                        'field': 'open'
                    };
                    if (bourse == 'huobi') {
                        param['starttime'] = resp.result+'/00_00';
                        param['endtime'] = timeStr.endTime+'/23_59';
                    } else {
                        param['starttime'] = timeReduce(resp.result+' 00:00', 8)
                        param['endtime'] = timeReduce(timeStr.endTime+' 23:59', 8)
                    }
                    get(url, param).then(resp => {
                        if (resp.code === 200) {
                            resolve(resp.data);
                        } else {
                            this.$notify.error({
                                message: resp.info,
                                title: '提示',
                                offset: 100
                            })
                        }
                    });
                });
            })
        },

        // 数据整理
        handleData(Currencys, timeNode, timeRange) {
            var transTypeArr = ['CQ', 'NW', 'CW', 'CS', 'SS'];
            var a_index = transTypeArr.indexOf(this.aType);
            var b_index = transTypeArr.indexOf(this.bType);
            this.aDataY = [];
            this.bDataY = [];
            this.dataX = [];
            this.dataY = [];
            // 请求 a交易所数据
            this.getKlineData(this.aType, Currencys.aCurrencys, timeNode, timeRange, this.bourseObj.aBourse).then((data) => {
                var this_data = data[Currencys.aCurrencys];
                for (var i=0; i<this_data.length; i++) {
                    this.dataX.push(this_data[i].candle_begin_time);
                    this.aDataY.push(this_data[i].close);
                }
            });
            // 请求 b交易所数据
            this.getKlineData(this.bType, Currencys.bCurrencys, timeNode, timeRange, this.bourseObj.bBourse).then((data) => {
                var this_data = data[Currencys.bCurrencys];
                for (var i=0; i<this_data.length; i++) {
                    // this.dataX.push(this_data[i].candle_begin_time);
                    this.bDataY.push(this_data[i].close);
                }
            });
            // console.log(timeRange)
            var timer = setInterval(() => {
                if (this.aDataY.length !== 0 && this.bDataY.length !== 0) {
                    clearInterval(timer);

                    for (var i=0; i<this.aDataY.length; i++) {// 遍历 a交易所的数据
                        // 价差 = (远期-近期) / 近期
                        var diff_dataY = 0;
                        if (a_index <= b_index) {// a: 远期，b: 近期
                            diff_dataY = (Number(this.aDataY[i]) - Number(this.bDataY[i]))/Number(this.bDataY[i])*100;
                            this.dataY.push(diff_dataY.toFixed(4));
                        } else if (a_index > b_index) {// a: 近期，b：远期
                            diff_dataY = (Number(this.bDataY[i]) - Number(this.aDataY[i])) / Number(this.aDataY[i])*100;
                            this.dataY.push(diff_dataY.toFixed(4));
                        }
                    }
                    var reverse_dataX = this.dataX.reverse();
                    var reverse_dataY = this.dataY.reverse();

                    for (let i=0; i<reverse_dataX.length; i++) {
                        if (this.timeRank.includes('H')) {
                            this.xData.unshift(reverse_dataX[i]);
                        } else {// 第一个数据两个数组都有，从1开始推入
                            if (this.bourseObj.aBourse == 'okex' && this.bourseObj.bBourse == 'okex') {
                                if (i >= 1) {
                                    this.xData.unshift(reverse_dataX[i]);
                                }
                            } else {
                                this.xData.unshift(reverse_dataX[i]);
                            }
                        }
                    }

                    for (let i=0; i<reverse_dataY.length; i++) {
                        if (this.timeRank.includes('H')) {
                            this.yData.unshift(reverse_dataY[i]);
                        } else {// 第一个数据两个数组都有，从1开始推入
                            if (this.bourseObj.aBourse == 'okex' && this.bourseObj.bBourse == 'okex') {
                                if (i >= 1) {
                                    this.yData.unshift(reverse_dataY[i]);
                                }
                            } else {
                                this.yData.unshift(reverse_dataY[i]);
                            }
                        }
                    }
                }
            }, 1000)
        },

        // 获取k线数据(新)
        getKlineData(type, currency, timeNode, timeRange, bourse) {
            return new Promise((resolve, reject) => {
                var url =  this.$url_LN + '/web/get/kline/data';
                var param = {
                    'excheng': bourse,
                    'currencys': JSON.stringify(currency),
                    'types': type,
                    'granularity': timeNode || '1T',
                    'field': 'open'
                };
                if (bourse == 'huobi') {
                    param['starttime'] = timeRange.startTime+'/00_00';
                    param['endtime'] = timeRange.endTime+'/23_59';
                } else {// 不是huobi, 向前减去8小时
                    let startTime = timeReduce(timeRange.startTime+' 00:00', 8);
                    let endTime = timeReduce(timeRange.endTime+' 23:59', 8)
                    param['starttime'] = startTime;
                    param['endtime'] = endTime;
                }
                // console.log(timeRange);
                get(url, param).then(resp => {
                    if (resp.code === 200) {
                        resolve(resp.data);
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100
                        })
                    }
                });
            })
        },

        // 当前时间字符串拼接
        UTCtimeStr() {
            // 获取当前时间
            var date1 = new Date();
            var month = date1.getUTCMonth() + 1;
            var date = date1.getUTCDate();
            var year = date1.getUTCFullYear();
            var hour = date1.getUTCHours();
            var minutes = date1.getUTCMinutes();

            if (month > 0 && month < 10) {
                month = '0' + month;
            }
            if (date > 0 && date < 10) {
                date = '0' + date;
            } 
            if (hour >= 0 && hour < 10) {
                hour = '0' + hour;
            }
            if (minutes >= 0 && minutes < 10) {
                minutes = '0' + minutes;
            }

            // 获取一周前的时间
            var date2 = new Date(date1);
            date2.setDate(date1.getDate() - 7);
            var monthB = date2.getUTCMonth() + 1;
            var dateB = date2.getUTCDate();
            var yearB = date2.getUTCFullYear();
            var hourB = date2.getUTCHours();
            var minutesB = date2.getUTCMinutes();
            if (monthB > 0 && monthB < 10) {
                monthB = '0' + monthB;
            }
            if (dateB > 0 && dateB < 10) {
                dateB = '0' + dateB;
            } 
            if (hourB >= 0 && hourB < 10) {
                hourB = '0' + hourB;
            }
            if (minutesB >= 0 && minutesB < 10) {
                minutesB = '0' + minutesB;
            }

            return {
                // 'endTime': year+'-'+month+'-'+date+'/'+hour+'_'+minutes,
                // 'startTime': yearB+'-'+monthB+'-'+dateB+'/'+hourB+'_'+minutesB,
                'endTime': year+'-'+month+'-'+date,
                'startTime': yearB+'-'+monthB+'-'+dateB,
            };
        },

        // 推算起始 参数拼接
        getStartTime(timeRank, dateTime) {
            if (timeRank) {
                var param = {
                    'startTime': dateTime
                }

                if (timeRank == '4H') {
                    // 时段为 4小时
                    param['distanceDays'] = '-24D';
                } else if (timeRank == '1H') {
                    // 时间段为 1小时
                    param['distanceDays'] = '-6D';
                } else if (timeRank == '2H') {
                    param['distanceDays'] = '-1D';
                } else if (timeRank.indexOf('D') !== -1) {
                    // 时段为 天
                    param['distanceDays'] = '-144D';
                } else if (timeRank.indexOf('W') !== -1) {
                    // 时段为 周
                    param['distanceDays'] = '-24W';
                } else if (timeRank == '1T') {
                    param['distanceDays'] = '-1D';
                } else if (timeRank == '30T') {
                    param['distanceDays'] = '-3D';
                }
                return param;
                
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .chart{
        width: 100%;
        height: 300px;
    }
</style>
